import { TEST_ACTIONS, TypeOfTestTemplateAction  } from '../types/TypeOfTestTemplateAction';
import { TypeOfTestTemplateBody } from '../types/TypeOfTestTemplateBody';


interface testTemplateTypeState {
    list: TypeOfTestTemplateBody[],
    error: string | "",
    activeTestType: any,
  };
  
  const initialState: testTemplateTypeState = {
    list: [],
    error: "",
    activeTestType: {}
  };


const contentSubTypeReducer = (state = initialState, action: TypeOfTestTemplateAction) => {
    switch (action.type) {
      case 'typeOfTestTemplate_SUCCESS': {
        return { ...state, list: action.data }
      }
      case 'typeOfTestTemplate_FAILED': {
        return { ...state, error: action.data }
      }
      case TEST_ACTIONS.SET_ACTIVE_TEST_TYPE:
        return { ...state, activeTestType: action.data };
      default:
        return state;
    }
  }


export default contentSubTypeReducer;